import axios from '@/plugins/axios';
import { MostAppreciatedEntry, MostAppreciatedType } from '@/models/MostAppreciated';

export default {
  async getMostAppreciated(type:MostAppreciatedType):Promise<MostAppreciatedEntry[]> {
    return axios.get(`/v1/reports/talks/contributors?filter=${type}`).then(({ data }) => data);
  }
};
